module.exports = __webpack_public_path__ + "static/media/team-michael.ab1c5fef.jpg";